import { decrypt, encrypt } from '@/helpers/encryption';
import { STORAGE, useLocalStorageStore } from '@/store/localStorageStore';

export enum REASON_FOR_UPDATING_USER {
  VISIT = 'VISIT',
  LOGIN = 'LOGIN',
  REGISTRATION = 'REGISTRATION',
  DEPOSIT = 'DEPOSIT',
  REFRESH_STATUSES = 'REFRESH_STATUSES',
  EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION',
}

export const USER_REFRESH_INTERVAL = 60e3;
export const SHOW_EMAIL_POPUP_AGAIN_AFTER_DAYS = 7;

export const CONFIRMATION_EMAIL_ROUTE = '/users/confirmation';

export enum ConfirmEmailOption {
  A_NO_VERIFICATION = 'a_no_verification',
  B_VERIFICATION_REMINDER_HEADER = 'b_verification_reminder_header',
}

export const saveUserEmail = (email?: string) => {
  if (email == null) return;

  useLocalStorageStore.getState().replace(STORAGE.USER_EMAIL, encrypt(email));
};

export const saveUserId = (id?: string) => {
  if (id == null) return;

  useLocalStorageStore.getState().replace(STORAGE.USER_ID, encrypt(id));
};

export const getUserId = () => {
  const value = useLocalStorageStore
    .getState()
    .get<string | null>(STORAGE.USER_ID);

  if (value == null) return;

  return decrypt(value);
};
